import { render, staticRenderFns } from "./DisplayProductColorsNew.vue?vue&type=template&id=2c67d064"
import script from "./DisplayProductColorsNew.vue?vue&type=script&lang=js"
export * from "./DisplayProductColorsNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports